<template>
  <div>
    <search ref="searchForm" :searchForm="searchForm" :loading="loading"
            :stationsForSelect="stationsForSelect"
            :operatorTree="operatorTree"
            @operatorSelect="operatorSelect"
            @submitForm="getData"></search>
    <el-col :span="1.5">
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openAdd"
                 v-if="checkPermission(['bee:res:appoint:addConf'])">{{ $t('tian-jia-she-zhi') }}</el-button>
    </el-col>
    <el-table :data="tableData" stripe style="width: 100%" ref="recordTable" border
              v-loading="loading">
      <af-table-column prop="appointName" :label="$t('yu-yue-ming-cheng-0')"></af-table-column>
      <af-table-column prop="operatorName" :label="$t('deviceControl.operatorId')"></af-table-column>
      <af-table-column prop="stationName" :label="$t('siteMonitor.stationName')"></af-table-column>
      <af-table-column prop="maxNum" :label="$t('zui-da-shi-yue-ci-shu-1')"></af-table-column>
      <af-table-column prop="appointTimes" :label="$t('ti-qian-shi-jian-liang-fen')"></af-table-column>
      <af-table-column prop="targetIntegral" :label="$t('yu-yue-yu-zhi-ji-fen')"></af-table-column>
      <af-table-column prop="deductIntegral" :label="$t('shi-yue-chao-shi-kou-fen')"></af-table-column>
      <af-table-column prop="beginTime" :label=" $t('sheng-xiao-ri-qi-0')" :formatter="dateFormatter">
          <template slot-scope="scope">
              {{scope.row.beginTime}} {{ $t('zhi') }} {{scope.row.endTime}}
          </template>
      </af-table-column>
      <af-table-column prop="timeSlots" :label="$t('sheng-xiao-shi-jian-duan-0')">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.timeSlots" :style="{height: '26px', lineHeight: '24px', display: 'block'}"
                  v-for="(item, index) in getTimeSlots(scope)"
                  :key="index">
            {{ item }}
          </el-tag>
          <el-tag v-if="getTimeSlots(scope) === ''" >{{ $t('24h-sheng-xiao') }}</el-tag>
        </template>
      </af-table-column>
      <af-table-column prop="createTime" :label="$t('chuang-jian-shi-jian')"></af-table-column>
      <af-table-column prop="updateTiem" :label="$t('zui-hou-geng-xin-shi-jian')"></af-table-column>
      <!--<el-table-column prop="createTime" label="创建时间" :formatter="dateFormatter"></el-table-column>-->
      <af-table-column :label="$t('deviceControl.operation')" width="280px" fixed="right">
        <template slot-scope="scope" >
          <el-tooltip :content="scope.row.state.message" placement="top" v-if="checkPermission(['bee:res:appoint:editConf'])">
            <el-switch
              :style="{marginRight: '10px'}"
              v-model="scope.row.state.code"
              :active-value="0"
              :inactive-value="1"
              disabled
              @click.native="updateConfState(scope.$index, scope.row)">
            </el-switch>
          </el-tooltip>
          <el-button size="mini" plain @click="openEdit(scope.$index, scope.row)"
                     v-if="checkPermission(['bee:res:appoint:editConf'])">{{ $t('alaramMonitor.edit') }}
          </el-button>
          <el-button size="mini" plain @click="detail(scope.$index, scope.row)">
            {{ $t('xiang-qing') }}
          </el-button>
          <el-button size="mini" plain type="danger" @click="deleteRow(scope.$index, scope.row)"
                     v-if="checkPermission(['bee:res:appoint:deleteConf'])">{{ $t('deviceControl.delete') }}
          </el-button>
        </template>
      </af-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination :child-msg="pageParam" @callFather="getData"></Pagination>
    <My-modal
      type="add"
      :visible="addVisible"
      :loading="addLoading"
      :operatorTree="operatorTree"
      :stationsForSelect="stationsForSelect"
      :gunTree="gunTree"
      @close="closeDialog"
      @submit="addSubmit"
      @operatorSelect="operatorSelect"
      @stationSelect="stationSelect"
    ></My-modal>
    <My-modal
      type="edit"
      :visible="editVisible"
      :loading="editLoading"
      :operatorTree="operatorTree"
      :stationsForSelect="stationsForSelect"
      :gunTree="gunTree"
      :data="selectRowData"
      @close="closeDialog"
      @submit="editSubmit"
      @operatorSelect="operatorSelect"
      @stationSelect="stationSelect"
    ></My-modal>
    <Detail
      :visible="detailVisible"
      :detail-form="selectRowData"
      :gunTree="gunTree"
      @close="closeDialog"
    ></Detail>
  </div>
</template>

<script>
  import Search from './search'
  import appointApi from "../../../api/appointmentApi";
  import pileApi from '../../..//api/pileApi';
  import checkPermission from '@/common/permission'
  import commonApi from "../../../api/commonApi";
  import Pagination from "../../../../../components/Pagination";
  import MyModal from './add'
  import Detail from './detail'

  export default {
    name: "list",
    components: {
      Search,
      Pagination,
      MyModal,
      Detail
    },
    data() {
      return {
        searchForm: {},
        tableData: [],
        loading: false,
        addLoading: false,
        addVisible: false,
        selectRowData: {},
        editLoading: false,
        editVisible: false,
        detailVisible: false,
        operatorTree: [], // 运营商树
        stationsForSelect: [],
        gunTree: [],
        // 分页参数
        pageParam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
      }
    },
    methods: {
      getTimeSlots(slot) {
        if(slot.row.timeSlots){
          let list = slot.row.timeSlots.split(',')
          return list
        }
        return ''
      },
      getData() {
        this.$refs.searchForm.$children[0].validate((valid) => {
          if (!valid) {
            return;
          }
          this.loading = true
          this.pageParam.t = this.searchForm
          let param = Object.assign({}, this.pageParam)
          appointApi.getAppointConfs(param).then((res) => {
            if (res.code === 0) {
              this.pageParam.total = res.data.total
              this.tableData = res.data.list
            } else {
              this.$message.error(res.message)
            }
            this.loading = false
          })
        })
      },
      // 编辑
      openAdd() {
        this.loadSelectItem();
        this.addVisible = true
      },
      // 编辑
      openEdit(index, row) {
        this.loadSelectItem(row.operatorId, row.stationCode);
        if (row !== undefined) {
          this.selectRowData = Object.assign({}, row)
          this.editVisible = true
        }
      },
      // 详情
      detail(index, row) {
        this.stationSelect(row.stationCode)
        if (row !== undefined) {
          this.selectRowData = Object.assign({}, row)
          this.detailVisible = true
        }
      },
      addSubmit(form) {
        console.log(form);
        this.$confirm(this.$t('deviceControl.AreYouSureToSubmit'), this.$t('deviceControl.prompt'), {}).then(() => {
          this.addLoading = true
          appointApi.adConf(form).then((res) => {
            this.addLoading = false
            if (res.code === 0) {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.addVisible = false
              this.getData()
            } else {
              this.addLoading = false
              this.$message.error(res.message)
            }
          }).catch(error => {
            this.addLoading = false
          })
        }).catch(_ => {
        })
      },
      submit(callback) {
        callback()
      },
      editSubmit(form) {
        console.log(form);
        this.$confirm(this.$t('deviceControl.AreYouSureToSubmit'), this.$t('deviceControl.prompt'), {}).then(() => {
          this.editLoading = true
          appointApi.editConf(form).then((res) => {
            this.editLoading = false
            if (res.code === 0) {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.editVisible = false
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          }).catch((error)=>{
            this.editLoading = false
          })
        }).catch(_ => {
        })
      },
      // 删除
      deleteRow(index, row) {
        this.$confirm(this.$t('que-ding-yao-shan-chu') + row.appointName + this.$t('ma-0'), this.$t('alaramMonitor.message5'), {
          confirmButtonText: this.$t('deviceControl.confirm'),
          cancelButtonText: this.$t('alaramMonitor.cancel'),
          type: 'warning'
        }).then(() => {
            this.loading = true
            let param = row.id
            appointApi.deleteConf(param).then((res) => {
              if (res.code === 0) {
                this.$message({
                  message: res.message,
                  type: 'success'
                })
                this.getData()
              } else {
                this.$message.error(res.message)
              }
              this.loading = false
            })
          }) .catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消删除！'
            // })
          })
      },
      // 日期格式化
      dateFormatter(row, column, cellValue, index) {
        let datetime = cellValue+"";
        return datetime.substring(0,10)
      },
      // 加载下拉框
      loadSelectItem(operatorId, stationCode) {
        let operatorIds
        if(operatorId) {
          operatorIds = [operatorId]
        }else {
          operatorIds = this.$store.getters.operatorIds
        }
        commonApi.stationsForSelectByOperatorId(operatorIds).then((res) => {
          if (res.code === 0) {
            this.stationsForSelect = res.data;
          }
        });
        // 运营商下拉框
        commonApi.getOperatorsTree().then((res) => {
          if (res.code === 0) {
            this.operatorTree = res.data;
          }
        });
        if(stationCode) this.stationSelect(stationCode)
      },
      operatorSelect(val) {
        commonApi.stationsForSelectByOperatorId([val]).then((res) => {
          if (res.code === 0) {
            this.stationsForSelect = res.data
          }
        })
      },
      // 编辑场站选中时
      stationSelect(val) {
        appointApi.getGunTree(val).then((res) => {
          if (res.code === 0) {
            this.gunTree = [res.data]
          }
        })
      },
      // 关闭弹框
      closeDialog(type) {
        // console.log('type:' + type)
        if (type === 'add') {
          this.addVisible  = false
        }else if(type === 'edit') {
          this.editVisible  = false
        }else if(type === 'detail') {
          this.detailVisible  = false
        }
      },
      updateConfState: function (index, row) {
        if (!checkPermission(['bee:res:appoint:updateState'])) {
          this.$message({type: 'error', message: this.$t('wu-cao-zuo-quan-xian')})
          return
        }
        let title = '', state = ''
        if(row.state.code === 0) {
          title = this.$t('que-ren-xiu-gai-zhuang-tai-wei-bu-kai-qi')
          state = '1'
        }else{
          title = this.$t('que-ren-xiu-gai-zhuang-tai-wei-kai-qi')
          state = '0'
        }
        this.$confirm(title, this.$t('deviceControl.prompt'), {
          confirmButtonText: this.$t('deviceControl.confirm'),
          cancelButtonText: this.$t('alaramMonitor.cancel'),
          type: 'warning'
        }).then(async () => {
          this.$message({type: 'info', message: this.$t('zheng-zai-qing-qiu-xiu-gai-qing-shao-hou')})
          await appointApi.updateConfState({id: row.id, state: state})
          this.$message({type: 'success', message: this.$t('cao-zuo-cheng-gong')})
          this.getData()
        }).catch(() => {

        })
      }
    },

    created: function () {
      this.loadSelectItem();
    },
    mounted: function () {
      this.getData()
    }
  }
</script>

<style scoped>
  /deep/ .el-switch.is-disabled .el-switch__core, /deep/ .el-switch.is-disabled .el-switch__label {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/appointmentManager/appointmentSettings/list.vue